import { useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'
import { AnimatePresence } from 'framer-motion'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { BsFillStopwatchFill } from 'react-icons/bs'
import Empty from '../../components/Display/Empty'
import Message from '../../views/VirtualAssistant/Message'
import SendMessage from '../../views/VirtualAssistant/SendMessage'
import NewMessageAnimation from '../../assets/animations/new-message.json'
import Lottie from 'react-lottie'
import { ThemeContext } from '../../context/ThemeContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { AiOutlineWhatsApp } from 'react-icons/ai'
import { onGetFileFromS3 } from '../../utils/UploadFile'
import saveAs from 'file-saver'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { Tooltip } from '@mui/material'
import DownloadImage from '../../assets/images/download.svg'
import ThumbUpGreen from '../../assets/images/thumb-up-green.svg'
import ThumbUp from '../../assets/images/thumb-up.svg'
import ThumbDownRed from '../../assets/images/thumb-down-red.svg'
import ThumbDown from '../../assets/images/thumb-down.svg'
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

const server = process.env.REACT_APP_SERVER_URL
const serverIA = process.env.REACT_APP_SERVER_URL_IA

export const ChatIAView = () => {
  const today = new Date()

  const location = useLocation()
  const data = location.state as any

  const history = useHistory()

  const { theme } = useContext(ThemeContext)

  const { addAlert } = useSnackBars()

  const getTime = () => {
    const date = new Date()
    let hours = date.getHours()
    let minutes: any = date.getMinutes()
    let ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // las 12 en punto son las 12 pm
    minutes = minutes < 10 ? '0' + minutes : minutes
    return `${hours}:${minutes} ${ampm}`
  }

  const [messages, setMessages] = useState<IMessage[]>([])

  //   const messages: { content: string; role: 'user' | 'assistant' }[] = [
  // {
  //   content:
  //     'Hola, soy Nevula, tu asistente financiero virtual. ¿Cómo puedo ayudarte?',
  //   role: 'assistant',
  // },
  // {
  //     content:
  //     'Hola, soy Nevula, tu asistente financiero virtual. ¿Cómo puedo ayudarte?',
  //   role: 'assistant',
  // },
  // {
  //     content:
  //     'Hola, soy Nevula, tu asistente financiero virtual. ¿Cómo puedo ayudarte?',
  //   role: 'assistant',
  // },
  // {
  //     content:
  //     'Hola, soy Nevula, tu asistente financiero virtual. ¿Cómo puedo ayudarte?',
  //   role: 'user',
  // },
  // {
  //     content:
  //     'Hola, soy Nevula, tu asistente financiero virtual. ¿Cómo puedo ayudarte?',
  //   role: 'assistant',
  // },
  //   ]

  const inputRef = useRef<HTMLInputElement | null>(null)

  const messagesRef = useRef<HTMLDivElement>(null)

  const [windowSize, setWindowSize] = useState(getWindowSize())

  const [tenantInfo, setTenantInfo] = useState<any>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const [conversationId, setConversationId] = useState<string>('')

  const user = useSelector((state: RootState) => state?.auth?.user)

  const getTenant = async () => {
    let tenantInfo = await axios.get(`${server}/user/tenant`)
    setTenantInfo(tenantInfo?.data?.tenant)
  }

  useEffect(() => {
    getTenant()
  }, [])

  useEffect(() => {
    if (messages) {
      if (messagesRef.current) {
        messagesRef.current.scrollTop = messagesRef.current.scrollHeight
      }
    }
  }, [messages])

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const getDate = (): string => {
    const date = new Date()
    const dayWeek = date.toLocaleDateString('es-ES', { weekday: 'long' })
    const day = date.getDate()
    const month = date.toLocaleDateString('es-ES', { month: 'long' })
    const year = date.getFullYear()
    const longDate = `${dayWeek}, ${day} de ${month} de ${year}`
    return longDate
  }

  const onLikeMessage = async (index: number, value: boolean) => {
    let message = messages[index]

    if (message.isLiked !== undefined) {
      return
    }

    message.isLiked = value

    let response = await axios.post(`${server}/nevula-ai/rating`, {
      question: messages[index - 1].content, //El mensaje del usuario es el anterior al mensaje del asistente
      answer: message.content,
      positive: value,
      tenantId: user['custom:tenant_id'],
    })

    setMessages((prevState) => {
      let newState = [...prevState]
      newState[index] = message
      return newState
    })

    // let response = await axios.post("/v1/ai/like", {
    //   message: message.message,
    //   thread_id: conversationId,
    // });

    // setMessages((prevState) => {
    //   let newState = [...prevState];
    //   newState[index].isLiked = true;
    //   return newState;
    // });
  }

  return (
    <div>
      <div
        className="flex flex-row justify-between items-center"
        style={{ backgroundColor: '#006AEA', height: 60, padding: 0 }}
      >

        <div className='flex items-center'>

          <div>
            <IoChatbubbleEllipsesSharp
              style={{ color: 'white' }}
              size={30}
              className='mx-2'
            />
          </div>

          <label className='text-white'>Asistente virtual</label>
        </div>

      </div>

      <div
        className={windowSize.innerWidth < 750 ? '' : 'px-20'}
        style={{ height: windowSize.innerHeight - 136, position: 'relative' }}
      >
        <div className="flex justify-end mb-5">
          {/* 
        <div className='flex flex-row items-center' onClick={() => {
          window.open(
            `https://api.whatsapp.com/send?phone=13055752896`,
            '_blank'
          )
        }}>
        <AiOutlineWhatsApp className='mr-1 text-primary' size={20} />
 
        <label
              style={{ color: '#006AEA', fontWeight: 600 }}
              className="mr-2 cursor-pointer"
            >
              Conversa via Whatsapp
            </label>
        </div> */}

          {tenantInfo?.aiAvailableQ > 0 ? (
            <div className="flex items-center mt-3 mr-2">
              <BsFillStopwatchFill
                style={{ color: '#B1A9A9' }}
                className="mr-2"
              />
              <label
                style={{ color: '#006AEA', fontWeight: 600 }}
                className="mr-2"
              >
                Preguntas disponibles:
              </label>
              <label style={{ color: '#B1A9A9', fontWeight: 600 }}>
                {tenantInfo?.aiAvailableQ}
              </label>
            </div>
          ) : (
            <label
              style={{ color: '#006AEA', fontWeight: 600 }}
              className="mr-2"
            >
              No tienes preguntas disponibles
            </label>
          )}
        </div>

        <div className="flex flex-row items-center">
          <div
            style={{ height: 1, width: '100%', backgroundColor: 'gray' }}
            className="ml-2"
          ></div>
          <label
            className="m-2"
            style={{ color: 'gray' }}
          >{`${today.getDate()}/${today.getMonth()}/${today.getFullYear()}`}</label>

          <div
            style={{ height: 1, width: '100%', backgroundColor: 'gray' }}
            className="mr-2"
          ></div>
        </div>

        {windowSize.innerWidth > 750 && (
          <div className="flex" style={{ position: 'relative' }}>
            <div
              style={{ height: 1, width: '100%', backgroundColor: '#414141' }}
            ></div>
            <div
              style={{
                backgroundColor: theme === 'dark' ? '#121519' : 'white',
                position: 'absolute',
                top: -12,
                left: '50%',
                transform: 'translate(-50%, 0)',
                zIndex: 1,
                paddingRight: 20,
                paddingLeft: 20,
              }}
            >
              <label
                style={{
                  color: theme === 'dark' ? '#DFDFDF' : '#B1A9A9',
                  fontWeight: 600,
                }}
              >
                {/* Hoy, 2 de Marzo 2023 */}
                {getDate()}
              </label>
            </div>
          </div>
        )}

        <div
          ref={messagesRef}
          style={{
            marginTop: 20,
            overflow: 'auto',
            maxHeight: (windowSize.innerHeight - 100) * 0.72,
          }}
        >
          {messages.length > 0 &&
            messages.map((message, index) => (
              <>
                <div style={{ marginTop: 20 }}>
                  <Message
                    body={message.content}
                    user={message.role}
                    time={message.time}
                    message={message}
                  />
                </div>

                {message?.role === 'assistant' && (
                  <div
                    style={{
                      marginLeft: 86,
                      marginTop: 1,
                      flexDirection: 'row',
                      display: 'flex',
                    }}
                  >
                    <img
                      onClick={() => {
                        onLikeMessage(index, true)
                      }}
                      src={message?.isLiked === true ? ThumbUpGreen : ThumbUp}
                      className="hover:opacity-100"
                      style={{
                        marginRight: 10,
                        height: 27,
                        width: 27,
                        cursor: 'pointer',
                        opacity: 0.7,
                      }}
                    />

                    <img
                      onClick={() => {
                        onLikeMessage(index, false)
                      }}
                      src={
                        message?.isLiked === false ? ThumbDownRed : ThumbDown
                      }
                      className="hover:opacity-100"
                      style={{
                        height: 27,
                        width: 27,
                        cursor: 'pointer',
                        opacity: 0.7,
                      }}
                    />
                  </div>
                )}

                <div style={{ marginTop: 8 }}>
                  <>
                    {message?.fileToRender &&
                      message?.fileInfo?.type == 'image' && (
                        <div style={{ marginLeft: 90 }}>
                          <Tooltip
                            title={
                              <React.Fragment>
                                <img
                                  onClick={() => {
                                    saveAs(
                                      message?.fileToRender!,
                                      message?.fileInfo?.file_name!
                                    )
                                    // onSaveImage(message?.fileToRender!, message?.fileInfo?.file_name!)
                                  }}
                                  style={{ cursor: 'pointer' }}
                                  src={DownloadImage}
                                />
                              </React.Fragment>
                            }
                            placement="top-end"
                          >
                            <img
                              src={message?.fileToRender}
                              alt={message?.fileInfo?.file_name!}
                              width={800}
                              height={500}
                            />
                          </Tooltip>
                        </div>
                      )}
                  </>
                </div>
              </>
            ))}

          {messages.length === 0 && (
            <AnimatePresence>
              <Empty
                animationProps={{
                  animation: NewMessageAnimation,
                  width: 250,
                  height: 250,
                }}
              >
                <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                  No hay mensajes aun, escribe para verlos.
                </p>
              </Empty>
            </AnimatePresence>
          )}

          {/* {messages.length === 0 && (
          <AnimatePresence>
            <Empty
              animationProps={{
                animation: MantenimientoAnimation,
                width: 250,
                height: 250,
              }}
            >
              <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                Actualmente en mantenimiento
              </p>
            </Empty>
          </AnimatePresence>
        )} */}
        </div>

        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            paddingLeft: 'inherit',
            paddingRight: 'inherit',
          }}
        >
          <SendMessage
            loading={loading}
            ref={inputRef}
            isDisabled={tenantInfo?.aiAvailableQ === 0}
            // isDisabled={true}
            onSend={async () => {
              if (inputRef && inputRef.current) {
                const message = inputRef?.current?.value!

                const newMessages = [
                  ...messages,
                  {
                    role: 'user',
                    content: message,
                    time: getTime(),
                    isLiked: undefined,
                  } as IMessage,
                ]


                setMessages(newMessages)
                setLoading(true)
                inputRef.current.value = ''

                try {
                  let response = await axios.post(
                    `${server}/nevula-ai`,
                    {
                      prompt: newMessages?.map(x => ({role: x?.role, content: x?.content}))
                    }
                  )

                  await axios.patch(`${server}/nevula-ai`)

                  setTenantInfo((prevState) => ({
                    ...prevState,
                    aiAvailableQ: prevState?.aiAvailableQ - 1,
                  }))

                  if (
                    response?.data?.file &&
                    response?.data?.file?.type === 'image'
                  ) {
                    let image = await onGetFileFromS3(
                      response?.data?.file?.bucket_key
                    )
                    const buffer = await new Response(
                      image as any
                    ).arrayBuffer()
                    const blob = new Blob([buffer], { type: 'image/png' })

                    
                    if (response?.data?.usage >= 2500) {
                      setMessages((prevState : any) => [
                        ...prevState.slice(2),
                        {
                          time: getTime(),
                          content: response?.data?.response,
                          role: 'assistant',
                          fileInfo: response?.data?.file,
                          fileToRender: URL.createObjectURL(blob),
                          isLiked: undefined,
                        },
                      ])
                    } else {
                      setMessages((prevState) => [
                        ...prevState,
                        {
                          time: getTime(),
                          content: response?.data?.response,
                          role: 'assistant',
                          fileInfo: response?.data?.file,
                          fileToRender: URL.createObjectURL(blob),
                          isLiked: undefined,
                        },
                      ])
                    }

                   

                    setLoading(false)
                    return
                  }

                  if (
                    response?.data?.file &&
                    response?.data?.file?.type === 'file'
                  ) {
                    let image = await onGetFileFromS3(
                      response?.data?.file?.bucket_key
                    )
                    const buffer = await new Response(
                      image as any
                    ).arrayBuffer()
                    const blob = new Blob([buffer], { type: 'text/csv' })

                    if (response?.data?.usage >= 2500) {
                      setMessages((prevState) => [
                        ...prevState.slice(2),
                        {
                          time: getTime(),
                          content: response?.data?.response,
                          role: 'assistant',
                          fileInfo: response?.data?.file,
                          fileToRender: URL.createObjectURL(blob),
                          isLiked: undefined,
                        } as IMessage,
                      ])
                    } else {
                      setMessages((prevState) => [
                        ...prevState,
                        {
                          time: getTime(),
                          content: response?.data?.response,
                          role: 'assistant',
                          fileInfo: response?.data?.file,
                          fileToRender: URL.createObjectURL(blob),
                          isLiked: undefined,
                        } as IMessage,
                      ])
                    }

                  
                    setLoading(false)
                    return
                  }

                  if (response?.data?.usage >= 2500) {
                    setMessages((prevState) => [
                      ...prevState.slice(2),
                      {
                        time: getTime(),
                        content: response?.data?.response,
                        role: 'assistant',
                        isLiked: undefined,
                      } as IMessage,
                    ])
                  } else {

                  setMessages((prevState) => [
                    ...prevState,
                    {
                      time: getTime(),
                      content: response?.data?.response,
                      role: 'assistant',
                      isLiked: undefined,
                    } as IMessage,
                  ])

                  }

                  setLoading(false)
                } catch (err) {

                  setMessages((prevState) => [
                    ...prevState,
                    {
                      time: getTime(),
                      content:
                        'No podemos procesar tu mensaje, intenta de nuevo',
                      role: 'assistant',
                      isLiked: undefined,
                    } as IMessage,
                  ])
                } finally {
                  setLoading(false)
                }

                // try {
                //   const [response, _] = await Promise.all([axios.post(`${server}/nevula-ai`, {
                //     // prompt: newMessages.slice(-8).map((v) => ({
                //     //   role: v?.role,
                //     //   content: v?.content,
                //     // })),
                //     prompt: newMessages.slice(-8).reduce((a: any, b) =>  {
                //       if (b?.content !== 'Lo siento, no pude procesar tu petición') {
                //         return [...a, {role: b?.role, content: b?.content}]
                //       }
                //       return a
                //     }, [])
                //   } ,{timeout: 30000, timeoutErrorMessage: 'timeout'}), axios.patch(`${server}/nevula-ai`, {}, {timeout: 30000})])

                //   // const [response, _] = await Promise.all([axios.post(`${server}/nevula-ai`, {
                //   //   prompt: newMessages.slice(-8).map((v) => ({
                //   //     role: v?.role,
                //   //     content: v?.content,
                //   //   })),
                //   // }), axios.patch(`${server}/nevula-ai`, {})])

                //   setLoading(false)

                //   setMessages([
                //       ...newMessages,
                //       {
                //         role: 'assistant',
                //         content: response?.data?.response,
                //         time: getTime(),
                //       },
                //     ])

                  // if (response?.data?.usage >= 2500) {
                  //   setMessages([
                  //     ...newMessages.slice(2),
                  //     {
                  //       role: 'assistant',
                  //       content: response?.data?.response,
                  //       time: getTime(),
                  //     },
                  //   ])
                  // } else {
                  //   setMessages([
                  //     ...newMessages,
                  //     {
                  //       role: 'assistant',
                  //       content: response?.data?.response,
                  //       time: getTime(),
                  //     },
                  //   ])
                  // }

                //   setTenantInfo((prevState) => ({
                //     ...prevState,
                //     aiAvailableQ: prevState?.aiAvailableQ - 1,
                //   }))
                // } catch (err: any) {
                //   if (err?.message === 'timeout') {
                //     addAlert({
                //       message: 'Lo siento, no pude procesar la solicitud.',
                //       status: 'error',
                //     })
                //     return
                //   }

                //   // addAlert({
                //   //   message: 'Ha ocurrido un error',
                //   //   status: 'error',
                //   // })

                //   setMessages([
                //     ...newMessages,
                //     {
                //       role: 'assistant',
                //       content: 'Lo siento, no pude procesar tu petición',
                //       time: getTime(),
                //     },
                //   ])

                // } finally {
                //   setLoading(false)
                // }
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}

export interface IMessage {
  content: string
  role: 'assistant' | 'user'
  time: string
  fileInfo?: IFile
  fileToRender?: string
  //Si es undefined, no ha sido ni like ni dislike, si es true es like, si es false es dislike
  isLiked: undefined | boolean
}

interface IFile {
  bucket_key: string
  file_name: string
  type: string
}
